import { Component } from '@angular/core';
import { ControlWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-divider-widget',
  templateUrl: './divider.widget.html',
} )
export class DividerWidget extends ControlWidget {
  schema: JSONSchema;

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/divider.widget.ts